import { render } from "./LayoutBM.vue?vue&type=template&id=56e8e1b8"
import script from "./LayoutBM.vue?vue&type=script&lang=js"
export * from "./LayoutBM.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__